import type {
  InboxWorkflowCellComponent,
  InboxWorkflowFlowConfig,
} from "@kontextwerk/control-web-frame/inbox-workflow/contract"
import {
  buildFlowSteps,
  withHelp,
  workflowDefinition,
  workflowStep,
} from "../../_shared/_logic/registry-composition"
import { inboxWorkflowHelpDialogIds } from "../../_shared/_logic/help-dialog-ids"
import { createSourceCleanupStep, sourceCleanupCells } from "./steps/02_source_cleanup"
import { createVerifyCustomerStep, verifyCustomerCells } from "./steps/01_verify_customer"

export const customerContactCells: Record<string, InboxWorkflowCellComponent> = {
  ...verifyCustomerCells,
  ...sourceCleanupCells,
}

export const customerContactVerificationFlow: InboxWorkflowFlowConfig = {
  definition: workflowDefinition({
    flowKey: "customer_contact_verification",
    label: "Ansprechpartner zuordnen",
    subjectPolicy: "OPTIONAL",
    requirements: ["VERIFY_CUSTOMER", "UPDATE_SOURCE_CONTACT_DATA"],
    steps: [
      workflowStep({
        stepKey: "verify_customer",
        label: "Gemeldeten Ansprechpartner einordnen",
        componentKey: "customer_contact_verification.verify_customer",
        requirements: ["VERIFY_CUSTOMER"],
        outputKey: "customer",
      }),
      workflowStep({
        stepKey: "source_cleanup",
        label: "Im Kehrbezirksprogramm nachtragen",
        componentKey: "shared.source_cleanup",
        requirements: ["UPDATE_SOURCE_CONTACT_DATA"],
        outputKey: "source_cleanup",
      }),
    ],
  }),
  steps: buildFlowSteps({
    verify_customer: withHelp(
      createVerifyCustomerStep(true),
      inboxWorkflowHelpDialogIds.customerContactVerification,
    ),
    source_cleanup: withHelp(
      createSourceCleanupStep(),
      inboxWorkflowHelpDialogIds.customerContactVerificationSourceCleanup,
    ),
  }),
}
